import React from 'react';
import RewardsDashboardPageLegacy from './components/RewardsLegacy/RewardsConnectLegacy';

const RewardsWrapper = (routerProps) => (
    /* eslint-disable react/jsx-props-no-spreading */
    <RewardsDashboardPageLegacy {...routerProps} />
);

export default RewardsWrapper;
